import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import WorkDetail from "@/pages/WorkDetail";
import SmoothScroll from "@/components/SmoothScroll";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <SmoothScroll />
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/work/:slug" element={<WorkDetail />} />
                </Routes>
                <Toaster
                    position="bottom-right"
                    richColors
                    closeButton
                    toastOptions={{
                        style: {
                            fontFamily: "Work Sans, sans-serif",
                        },
                    }}
                />
            </BrowserRouter>
        </div>
    );
}

export default App;
